import { observer } from 'mobx-react';

import { DealSearchContent } from '@assets/component/DealSearch/DealSearchContent';
import { Header } from '@assets/component/Header/Header';
import { Flex } from '@assets/component/UI/Flex/Flex';
import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import { useStore, useStoreUI } from '@assets/model/Store';
import { useEffect } from 'react';
import { AdminSection } from '@assets/component/AdminSection/AdminSection';
import Chatbot from 'flowise-embed/dist/web.js';
const DealDBPage = observer(() => {
    const store = useStore();
    const uiStore = useStoreUI();

    useEffect(() => {
        getFirebase().store_audit_entry('VIEW_PAGE_DB', { page: 'DealDBPage' });
        Chatbot.destroy();
        uiStore.resetDealView();
    }, []);
    return (
        <>
            <div
                className="d-flex justify-content-center"
                style={{ height: '100%' }}
            >
                <AdminSection />
                <Flex direction="column" className="h-100 w-100">
                    <Header disableTicker={true} showNewDeal={true} />
                    <DealSearchContent />
                </Flex>
            </div>
        </>
    );
});

export default DealDBPage;
